'use client';

/**
 * Helper function to determine if middle truncation
 * is being used, mainly for typescript help.
 */

import type { MiddleTruncationDefintion, TextTruncation } from './types';

export function isMiddleTruncation(
  truncate?: TextTruncation
): truncate is MiddleTruncationDefintion {
  return (
    truncate !== undefined &&
    truncate !== null &&
    typeof truncate === 'object' &&
    truncate.type === 'middle'
  );
}
